import { gql } from '@apollo/client';

// Облегчённый запрос для списка курсантов: нужны только id участников и признак
// «просмотрено» у сообщений. Поля participants/owner/sender в getChats на каждый
// чат (десятки тысяч у администратора) делают отдельные запросы к БД.
export const GetStudentsChatsQuery = gql`
    query GetStudentsChats($type: ChatType) {
        getChats(type: $type) {
            id
            participantIds
            type
            messages {
                id
                viewed
            }
        }
    }
`;
